import { render, staticRenderFns } from "./EcommerceTotalBlockChainAccount.vue?vue&type=template&id=389605ce"
import script from "./EcommerceTotalBlockChainAccount.vue?vue&type=script&lang=js"
export * from "./EcommerceTotalBlockChainAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports